import React from 'react';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Typography from '@material-ui/core/Typography';
import Table from '@/modules/common/components/Table';
import TableContainer from '@/modules/common/components/TableContainer';
import Link from './Link';
import TableHead from './TableHead/TableHead';

function getTotalSum(report) {
    let totalSum = 0;
    // noinspection JSUnresolvedVariable
    Object.keys(report).forEach((offerName) => totalSum += report[offerName].sum);
    return totalSum;
}

const TableLeft = (props) => {
    // noinspection JSUnresolvedVariable
    return (
        <TableContainer className="table-container-left">
            <Table>
                <TableHead/>
                <TableBody>
                    {Object.keys(props.report).map((key, id) => (
                        <TableRow key={id}>
                            <TableCell className="primary">
                                <Typography noWrap={true}><Link value={key.substring(1)}/></Typography>
                            </TableCell>
                            <TableCell className="sum">
                                <Typography align="right">{props.report[key].sum}</Typography>
                            </TableCell>
                        </TableRow>
                    ))}
                    <TableRow className="row-total-count">
                        <TableCell className="primary"/>
                        <TableCell className="sum">
                            <Typography align="right">{getTotalSum(props.report)}</Typography>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};

TableLeft.propTypes = {
    report: PropTypes.object.isRequired,
};

export default TableLeft;
